import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e6919d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "订单列表", -1))
const _hoisted_3 = { class: "main" }

import { ref, onMounted } from 'vue'

import { GetOrder } from '../http/index'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonCenter',
  setup(__props) {

const store = useStore();
const list = ref();

const key=Math.random();

onMounted(async () => { 
    //list.value = (await GetOrder({ userCode:store.state.userCode })).result
    let data = (await GetOrder({ userCode:store.state.userCode})).data
   
     list.value=data?.result
    
})

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createBlock(_component_el_table, {
                data: list.value,
                key: _unref(key),
                height: "300",
                stripe: "",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "orderDate",
                    label: "订单日期",
                    width: "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "orderNumber",
                    label: "订单号",
                    width: "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "flowerTitle",
                    label: "商品标题"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "price",
                    label: "价格"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "userCode",
                    label: ""
                  })
                ]),
                _: 1
              }, 8, ["data"]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})